import { call, put, takeEvery } from 'redux-saga/effects';
import { atpApi } from 'config/axios';
import {
    FETCH_ADAPTIVE_PLAN_FEED,
    FETCH_ADAPTIVE_PLAN_FEED_SUCCESS,
    FETCH_ADAPTIVE_PLAN_FEED_ERROR,
    FETCHING_ADAPTIVE_PLAN_FEED
} from '../actions/ActionTypes';

// worker
export function* fetchAdaptivePlanFeed(action) {
    try {
        const { athletePlanId, lang } = action.payload;

        yield put({
            type: FETCHING_ADAPTIVE_PLAN_FEED
        });

        const response = yield call(atpApi.get, `/atp/athlete/feed?athletePlanId=${athletePlanId}&lang=${lang}`);

        yield put({
            type: FETCH_ADAPTIVE_PLAN_FEED_SUCCESS,
            atpFeed: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_ADAPTIVE_PLAN_FEED_ERROR
        });
    }
}

// watcher
export const atpFeedSagas = [takeEvery(FETCH_ADAPTIVE_PLAN_FEED, fetchAdaptivePlanFeed)];
